import {
  notifyInvitationExpired,
  getLoginResponseObj,
  getRegisterResponseObj,
  getUsernameResponseObj,
  getUserDetailsResponseObj,
  updateUserDetailsResponseObj,
  getChangePasswordResponseObj,
  resendInvitationMail,
  updateUserProfileDetailsResponseObj,
  logoutResponseObj,
  getAccountDataBySlug,
  getUserDetailsResponse,
} from '@/services/userService/users-api';
import APP_CONST from '@/constants/AppConst';
import APP_UTILITIES from '@/utilities/commonFunctions';
import store from '@/store';
import {
  TypeObj,
  RegisterObj,
  UserDetails,
  UpdatePasswordObj,
  UserProfileDetails,
} from '@/Model/model';
import {
  getModule,
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import router from '@/router';
import { ICreateUser } from '@/Model/programModel';
import MutationNames from '@/store/modules/commonEntry/mutationNames';
import { ApiErrorResponse, ApiErrorType } from '@/Model/error/api/types';
import { getAccountDetail } from '@/services/create-user/userService';

const {
  FETCH_ACCOUNT_DETAILS_BY_SLUG_REQUESTED,
  FETCH_ACCOUNT_DETAILS_BY_SLUG_FAILED,
  RESET_INITIAL_ACCOUNT_DETAILS_BY_SLUG_FETCH,
  FETCH_USER_DETAILS_REQUESTED,
  FETCH_USER_DETAILS_FAILED,
  RESET_INITIAL_USER_DETAILS_FETCH,
} = MutationNames;

@Module({
  namespaced: true,
  name: 'commonEntryStore',
  store,
  dynamic: true,
})
export class CommonEntryModule extends VuexModule {
  private email: string = '';
  private submitted: object | any = {};
  private rememberChecked: boolean = false;
  private privacyPolicyChecked: boolean = false;
  private emailTokenValidity: string = '';
  private firstName: string = '';
  private userDetails: any = {};
  private userProfileDetails: any = {};
  private accountDetails: any = {};
  public updateResponseObj: object = {};
  public createGuardian: ICreateUser = JSON.parse(
    JSON.stringify(APP_CONST.USER_CREATION)
  );
  public savedUserFirstName: string = '';
  public deviceFormatCheck: string = navigator.userAgent;
  public responsePending: boolean = false;
  public accountDesignInfo: any = [];
  public logoutResponsePending: boolean = false;
  public statusCode: number = -1;

  isFetchingAccountDetailsBySlug = false;
  isInitialAccountDetailsBySlugFetch = true;
  didFetchAccountDetailsBySlugFail = false;
  fetchAccountDetailsBySlugFailedError: ApiErrorResponse | null = null;

  isFetchingUserDetails = false;
  isInitialUserDetailsFetch = true;
  didFetchUserDetailsFail = false;
  fetchUserDetailsFailedError: ApiErrorResponse | null = null;

  get userDetail(): object {
    return this.userDetails;
  }

  get userProfileDetail(): object {
    return this.userProfileDetails;
  }

  get userUpdateResponse(): object {
    return this.updateResponseObj;
  }

  get userFirstName(): string {
    return this.firstName;
  }

  get getEmail(): string {
    return this.email;
  }

  get getRememberMe(): boolean {
    return this.rememberChecked;
  }

  get getPrivacyPolicyChecked(): boolean {
    return this.privacyPolicyChecked;
  }

  get getSubmit(): object | any {
    return this.submitted;
  }

  get tokenValidity(): string {
    return this.emailTokenValidity;
  }

  get getStatusCode() {
    return this.statusCode;
  }

  get savedUserName() {
    return this.savedUserFirstName;
  }

  get isResponsePending() {
    return this.responsePending;
  }

  get accountDesignDetails() {
    return this.accountDesignInfo;
  }

  get accountDetail() {
    return this.accountDetails;
  }

  get isLogoutResponsePending() {
    return this.logoutResponsePending;
  }

  @Mutation
  public setResponsePending(check: boolean) {
    this.responsePending = check;
  }

  @Mutation
  accountById(accountId: string) {
    return getAccountDetail(accountId).then(
      (response) => {
        this.accountDetails = response;
      },
      (error) => {
        this.accountDetails = { error: true };
      }
    );
  }

  @Mutation
  public setRememberMutate(payload: boolean): void {
    this.rememberChecked = payload;
  }

  @Action({ commit: 'setRememberMutate' })
  public setRememberMe(payload: { checked: boolean; type: string }): boolean {
    function validateEmail(mail: string) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(mail);
    }
    if (payload.checked && payload.type == 'login') {
      if (this.email.length !== 0 && validateEmail(this.email)) {
        APP_UTILITIES.setCookie(APP_CONST.USERNAME, this.email, APP_CONST.ONE);
      }
    } else {
      document.cookie = `${
        APP_CONST.USERNAME
      }=; expires=${new Date()}; path=/;`;
    }
    return payload.checked;
  }

  @Mutation
  public setPrivacyPolicyMutate(payload: boolean): void {
    this.privacyPolicyChecked = payload;
  }

  @Action({ commit: 'setPrivacyPolicyMutate' })
  public setPrivacyPolicy(payload: {
    checked: boolean;
    type: string;
  }): boolean {
    return payload.checked;
  }

  @Mutation
  public setEmailMutate(payload: string): void {
    this.email = payload;
  }

  @Action({ commit: 'setEmailMutate' })
  public setEmail(payload: string): string {
    return payload;
  }

  @Mutation
  public tokenMutate(payload: any) {
    if (payload.status == 200) {
      this.firstName = payload.data.firstName;
      this.email = payload.data.email;
    } else {
      this.emailTokenValidity = payload.data.Message;
      this.statusCode = payload.status;
    }
  }

  @Action({ commit: 'tokenMutate' })
  public getUsernameFromToken(tokenString: string) {
    const resultNew = async function getUsernameResponse(
      tokenString: string
    ): Promise<Object> {
      const promise = getUsernameResponseObj(tokenString);
      const result = await promise;
      return result as object;
    };
    return resultNew(tokenString);
  }

  @Action
  public onNotify(obj: any): Object {
    const resultNew = async function getNotifyResponse(
      obj: TypeObj
    ): Promise<Object> {
      const promise = notifyInvitationExpired(obj);
      const result = await promise;
      result.type = 'login';
      return result as object;
    };
    return resultNew(obj as TypeObj);
  }

  @Action
  public async login(obj: TypeObj): Promise<boolean> {
    this.setResponsePending(true);
    const response = await getLoginResponseObj();
    this.setSubmit(response);
    this.setResponsePending(false);
    if (response.status == APP_CONST.RESPONSE_200) {
      if (response.data.isFamilyPortal) {
        const userResponse = await getUserDetailsResponse();
        if (userResponse.status == APP_CONST.RESPONSE_200) {
          this.RESET_INITIAL_USER_DETAILS_FETCH();
          await this.fetchUserDetails(userResponse.data.userRoles[0].userId);
          this.loginFamilyPortal(userResponse.data);
        }
        this.setRememberMutate(false);
      } else {
        this.loginBxPortal();
      }
      return true;
    }
    return false;
  }

  @Mutation
  public loginFamilyPortal(userDetails: any) {
    APP_UTILITIES.setCookie(
      APP_CONST.USER_ID,
      userDetails && userDetails.id,
      APP_CONST.ONE
    );
    if (
      userDetails.userRoles[0].accountId !== this.accountDesignInfo.accountId
    ) {
      this.logoutResponsePending = true;
      this.submitted.data.alreadyAdded = true;
      logoutResponseObj().then((response) => {
        this.logoutResponsePending = false;
        /* istanbul ignore else */
        if (
          response.status === APP_CONST.RESPONSE_200 ||
          response.status === APP_CONST.RESPONSE_400
        ) {
          APP_UTILITIES.removeCookies();
        }
      });
    } else {
      const roles = userDetails.userRoles.map(
        (el: { roleId: number }) => el.roleId
      );
      const highestRole = Math.min(...roles);
      this.savedUserFirstName = userDetails.firstName;
      const role = userDetails.userRoles.find(
        (el: { roleId: number }) => el.roleId === highestRole
      );
      role.roleId = highestRole;
      const userRole = JSON.stringify(userDetails.userRoles);
      if (this.rememberChecked) {
        APP_UTILITIES.setCookie(APP_CONST.USERNAME, this.email, APP_CONST.ONE);
      } else {
        APP_UTILITIES.removeSpecificCookie(APP_CONST.USERNAME);
      }
      APP_UTILITIES.setCookie('user_role', userRole, 1);
      sessionStorage.setItem('user_role', userRole);
    }
  }

  @Mutation
  public loginBxPortal() {
    if (!this.isLogoutResponsePending) {
      this.logoutResponsePending = true;
      logoutResponseObj().then((response) => {
        this.logoutResponsePending = false;
        /* istanbul ignore else */
        if (
          response.status === APP_CONST.RESPONSE_200 ||
          response.status === APP_CONST.RESPONSE_400
        ) {
          APP_UTILITIES.removeCookies();
        }
      });
    }
  }

  @Mutation
  public setSubmit(response: any) {
    this.submitted = response;
  }

  @Action
  public async register(obj: RegisterObj) {
    this.setResponsePending(true);
    const refSource = obj.refSource;
    delete obj.refSource;
    const response = await getRegisterResponseObj(obj);
    response.refSource = refSource;
    this.setSubmit(response);
    this.setResponsePending(false);
    if (response.status == APP_CONST.RESPONSE_200) {
      if (response.refSource != 'web') {
        if (
          this.deviceFormatCheck.indexOf('Android') != -1 ||
          this.deviceFormatCheck.indexOf('iPhone') != -1 ||
          this.deviceFormatCheck.indexOf('iPad') != -1
        ) {
          window.location.replace(response.refSource + '://login');
        }
      }
    }
    return response;
  }

  @Action
  public async changePassword(obj: UpdatePasswordObj) {
    this.setResponsePending(true);
    const response = await getChangePasswordResponseObj(obj);
    this.setSubmit(response);
    this.setResponsePending(false);

    return response;
  }

  @Mutation
  public afterFetchMutate(payload: any) {
    this.userDetails = payload.data;
    this.userProfileDetails = this.userDetails;
    this.savedUserFirstName = this.userDetails.firstName;

    // Update fetching state on success
    this.isFetchingUserDetails = false;
    this.didFetchUserDetailsFail = false;
    this.fetchUserDetailsFailedError = null;
    if (this.isInitialUserDetailsFetch) {
      this.isInitialUserDetailsFetch = false;
    }
  }

  @Action
  public fetchUserDetails(id: number) {
    this.FETCH_USER_DETAILS_REQUESTED();
    const resultNew = async (id: number): Promise<Object> => {
      const promise = getUserDetailsResponseObj(id);

      const result = await promise;
      if (result.status !== 200) {
        const apiErrorResponse: ApiErrorResponse = APP_UTILITIES.errorToApiErrorResponse(
          result.data
        );
        if (result.status === 401) {
          apiErrorResponse.name = ApiErrorType.Error_Unauthorized;
        }
        this.FETCH_USER_DETAILS_FAILED(apiErrorResponse);
      } else {
        this.afterFetchMutate(result);
      }
      return result as object;
    };
    return resultNew(id);
  }

  @Mutation
  public afterUpdateMutate(payload: object) {
    this.updateResponseObj = payload;
  }

  @Action({ commit: 'afterUpdateMutate' })
  public updateUserDetails(userObj: any) {
    const updateResponse = async function updateUser(
      userObj: UserDetails
    ): Promise<Object> {
      const promise = updateUserDetailsResponseObj(userObj);
      const result = await promise;
      return result as object;
    };
    return updateResponse(userObj);
  }

  @Action({ commit: 'afterUpdateMutate' })
  public updateUserProfileDetailsResponseObj(userObj: any) {
    const updateResponse = async function updateUser(
      userObj: UserProfileDetails
    ): Promise<Object> {
      const promise = updateUserProfileDetailsResponseObj(userObj);
      const result = await promise;
      return result as object;
    };
    return updateResponse(userObj);
  }

  @Action
  public resendInvitationMail(obj: any) {
    const resultNew = async function resendInvitationMailfunc(
      tokenString: string
    ): Promise<Object> {
      const promise = resendInvitationMail(tokenString);
      const result = await promise;
      return result as object;
    };
    return resultNew(obj);
  }

  @Mutation
  public submitMutate(payload: any) {
    this.submitted = payload;
  }

  @Action({ commit: 'submitMutate' })
  public submitClear() {
    return {};
  }

  get guardianData() {
    return this.createGuardian;
  }

  @Mutation
  public mutateEmail(guardian: ICreateUser) {
    this.createGuardian = guardian;
  }

  @Mutation
  updateUserfirstName(userData: any) {
    this.savedUserFirstName = userData.firstName;
  }

  @Mutation
  mutateAccountDesignDetails(result: any) {
    if (result && result.accountDesign) {
      this.accountDesignInfo = result && result.accountDesign;
      delete result.accountDesign.id;
      delete result.accountDesign.guid;
      delete result.accountDesign.status;
      delete result.accountDesign.isAccountLoggedInByAnyUser;
      delete result.accountDesign.illustrationType;
      delete result.accountDesign.faviconFileName;
      delete result.accountDesign.logoFileName;
      result.accountDesign.slug = result.slug;
      result.accountDesign.accountId = result && result.accountId;
      result.accountDesign.accountName = result && result.accountName;
      APP_UTILITIES.setCookie(
        'accountDesign',
        JSON.stringify(result.accountDesign),
        1
      );
      localStorage.setItem('accountDesign', JSON.stringify(result));
    }

    // Update fetching state on success
    this.isFetchingAccountDetailsBySlug = false;
    this.didFetchAccountDetailsBySlugFail = false;
    this.fetchAccountDetailsBySlugFailedError = null;
    if (this.isInitialAccountDetailsBySlugFetch) {
      this.isInitialAccountDetailsBySlugFetch = false;
    }
  }

  @Mutation
  reset() {
    this.userDetails = {};
    this.userProfileDetails = {};
    this.savedUserFirstName = '';
    this.firstName = '';
    this.email = '';
  }

  @Action
  async getAccountDetailsBySlug(slug: string) {
    this.FETCH_ACCOUNT_DETAILS_BY_SLUG_REQUESTED();
    const response = await getAccountDataBySlug(slug);
    if (response.status == APP_CONST.RESPONSE_200) {
      if (response.data.status == 2) {
        router.push('/nolongeraccess');
      }
      if (
        response.data.accountDesign &&
        response.data.accountDesign.faviconUrl
      ) {
        const link: any =
          document.querySelector("link[rel*='icon']") ||
          document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = response.data.accountDesign.faviconUrl;
        localStorage.setItem('accountDesign', JSON.stringify(response.data));
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      this.mutateAccountDesignDetails(response.data);
      return response.data;
    } else {
      const apiErrorResponse: ApiErrorResponse = APP_UTILITIES.errorToApiErrorResponse(
        response.data
      );
      if (response.status === 401) {
        apiErrorResponse.name = ApiErrorType.Error_Unauthorized;
      }
      this.FETCH_ACCOUNT_DETAILS_BY_SLUG_FAILED(apiErrorResponse);
    }
  }

  @Mutation
  [FETCH_ACCOUNT_DETAILS_BY_SLUG_REQUESTED]() {
    this.isFetchingAccountDetailsBySlug = true;
    this.didFetchAccountDetailsBySlugFail = false;
    this.fetchAccountDetailsBySlugFailedError = null;
  }

  @Mutation
  [FETCH_ACCOUNT_DETAILS_BY_SLUG_FAILED](error: ApiErrorResponse) {
    this.isFetchingAccountDetailsBySlug = false;
    this.didFetchAccountDetailsBySlugFail = true;
    this.fetchAccountDetailsBySlugFailedError = error;
    if (this.isInitialAccountDetailsBySlugFetch) {
      this.isInitialAccountDetailsBySlugFetch = false;
    }
  }

  @Mutation
  [RESET_INITIAL_ACCOUNT_DETAILS_BY_SLUG_FETCH]() {
    this.isInitialAccountDetailsBySlugFetch = true;
  }

  @Mutation
  [FETCH_USER_DETAILS_REQUESTED]() {
    this.isFetchingUserDetails = true;
    this.didFetchUserDetailsFail = false;
    this.fetchUserDetailsFailedError = null;
  }

  @Mutation
  [FETCH_USER_DETAILS_FAILED](error: ApiErrorResponse) {
    this.isFetchingUserDetails = false;
    this.didFetchUserDetailsFail = true;
    this.fetchUserDetailsFailedError = error;
    if (this.isInitialUserDetailsFetch) {
      this.isInitialUserDetailsFetch = false;
    }
  }

  @Mutation
  [RESET_INITIAL_USER_DETAILS_FETCH]() {
    this.isInitialUserDetailsFetch = true;
  }
}

export default getModule(CommonEntryModule);
